



























import { Component, Vue, Prop } from "vue-property-decorator";
import PageHeader from "@/components/PageHeader.vue";
import VPageContentSticky from "@/components/VPageContentSticky.vue";

@Component({ components: { PageHeader, VPageContentSticky } })
export default class UnauthorizedPage extends Vue {
  @Prop({ default: "opened" }) readonly icon!: "opened" | "closed";

  get limePath() {
    return require(`@/assets/icons/login-sidebar.png`);
  }

  get brandPath() {
    return require(`@/assets/icons/brand-gray.svg`);
  }
}
